export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-open-white/f52b2d0d4d6647ec10577d5cd341c0b8.webp";